import React, { useState } from 'react';

interface IStudyInput {
	type?: string,
	value?: any,
	name?: string,
	heading?: string,
	options?: object,
}

interface IStudyModalInputProps {
	input: IStudyInput,
	updateInputs: (name: string, value: string | number | boolean) => void,
}

export const StudyModalInput: React.FunctionComponent<IStudyModalInputProps> = ({ input, updateInputs }) => {
	const [isChecked, setIsChecked] = useState<boolean>(input.value);

	const selectChangeHandler = (e: React.ChangeEvent<HTMLSelectElement>) => {
		const { name, value } = e.currentTarget;

		updateInputs(name, value);
  }

	const inputChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { name, type, value, checked } = e.currentTarget;

		if (type === 'number') {
			updateInputs(name, parseInt(value, 10));
		} else if (type === 'checkbox') {
			setIsChecked(checked);
			updateInputs(name, checked);
		} else {
			updateInputs(name, value);
		}
	}

	if (input) {
		if (input.type === 'select' && input.options) {
			const inputOptions: any[] = [];

			Object.keys(input.options).forEach(key => {
				inputOptions.push(<option key={'option' + key}>{key}</option>);
			});

			return (
				<div className="inputs dialog-item">
					<select name={input.name} defaultValue={input.value} onChange={selectChangeHandler}>
						{inputOptions}
					</select>
					<div>
						{input.heading}
					</div>
				</div>
			);
		} else if (input.type === 'checkbox') {
			return (
				<div className="inputs dialog-item">
					<input name={input.name} type="checkbox" checked={isChecked} onChange={inputChangeHandler} />
					<div>
						{input.heading}
					</div>
				</div>
			);
		}

		return (
			<div className="inputs dialog-item">
				<input name={input.name} type={input.type} defaultValue={input.value} onChange={inputChangeHandler} />
				<div>
					{input.heading}
				</div>
			</div>
		);
	}
	return <div />
};
